//其他入库

export default [

    {   // 入库计划单(管理端)
        path: "misc/inbound",
        name: "miscInbound",
        component: () => import(/* webpackChunkName: "inbound" */ "@/views/misc/inbound/index"),
    },
    {   //update 入库计划(管理端)
        path: "misc/inbound/update/:type",
        name: "miscInboundDetail",
        component: () => import(/* webpackChunkName: "inbound" */ "@/views/misc/inbound/update"),
    },

    {   // 出库计划单(管理端)
        path: "misc/outbound",
        name: "miscOutbound",
        component: () => import(/* webpackChunkName: "inbound" */ "@/views/misc/outbound/index"),
    },
    {   //update 出库计划(管理端)
        path: "misc/outbound/update/:type",
        name: "miscOutboundDetail",
        component: () => import(/* webpackChunkName: "inbound" */ "@/views/misc/outbound/update"),
    },

    {   // 换标上架计划（客户端）
        path: "insideplan/markchangecustom",
        name: "markChangeCustom",
        component: () => import("@/views/misc/markchangecustom/index"),
    },
    {   // 换标上架计划（管理端）
        path: "insideplan/markchangemanage",
        name: "markChangeManage",
        component: () => import("@/views/misc/markchangemanage/index"),
    },
    {   // update 换标上架计划
        path: "insideplan/markchange/update/:type",
        name: "markChangeDetail",
        component: () => import("@/views/misc/markchangecustom/update"),
    },
    {   // 换标上架单
        path: "insideplan/markchangeorder",
        name: "markChange",
        component: () => import("@/views/misc/markchange/index"),
    },
    {   // update 换标上架单
        path: "insideplan/markchangeorder/update/:type",
        name: "markChangeOrderDetail",
        component: () => import("@/views/misc/markchange/update"),
    },
    {   // 换标上架单
        path: "insideplan/markchangeorderout",
        name: "markChangeOut",
        component: () => import("@/views/misc/markchangesoldout/index"),
    },
    {   // update 换标上架单
        path: "insideplan/markchangeorderout/update/:type",
        name: "markChangeOrderOutDetail",
        component: () => import("@/views/misc/markchangesoldout/update"),
    },

    {   // FBA调拨
        path: "fbatransfer/fbalist",
        name: "fbaTransferList",
        component: () => import("@/views/misc/fbatransfer/index"),
    },
    {   // update FBA调拨 移入亚马逊
        path: "fbatransfer/fbalist/update/in/:type",
        name: "fbaTransferInDetail",
        component: () => import("@/views/misc/fbatransfer/update"),
    },
    {   // update FBA调拨 移入亚马逊
        path: "fbatransfer/fbalist/update/out/:type",
        name: "fbaTransferOutDetail",
        component: () => import("@/views/misc/fbatransfer/updateout"),
    },
    {   // 普通调拨
        path: "ordinarytransfer/ordinarylist",
        name: "ordinaryTransferList",
        component: () => import("@/views/misc/ordinarytransfer/index"),
    },
    {   // update 普通调拨 仓仓调拨
        path: "ordinarytransfer/ordinarylist/update/in/:type",
        name: "ordinaryTransferInDetail",
        component: () => import("@/views/misc/ordinarytransfer/update"),
    },
    {   // update 普通调拨 调拨出库
        path: "ordinarytransfer/ordinarylist/update/out/:type",
        name: "ordinaryTransferOutDetail",
        component: () => import("@/views/misc/ordinarytransfer/updateout"),
    },
    {   // 调拨管理
        path: "transfermanage/transfermanagelist",
        name: "transferManageList",
        component: () => import("@/views/misc/transfermanage/index"),
    },
]


